import { connect } from 'react-redux';
import Attributes from './attributes';
import { updateAttributes } from '../../actions/canvas';

const mapStateToProps = (state) => {
  const {
    canvas: {
      keywordList, colorList, associatedRoomIds, associatedHomeDecorStyleIds
    }
  } = state;

  return {
    keywordList, colorList, associatedRoomIds, associatedHomeDecorStyleIds
  };
};

export default connect(mapStateToProps, { updateAttributes })(Attributes);
